<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="用户账号" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户类型" prop="userType">
            <el-select v-model="queryForm.userType" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="item in allUserType"
                  :key="item.userTypeNum"
                  :label="item.userTypeName"
                  :value="item.userTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择状态">
              <el-option
                  v-for="item in statusOptions"
                  :key="item.flag"
                  :label="item.value"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;" @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="createTime" label="时间" />
      <el-table-column prop="userName" label="交易流水号" />
      <el-table-column prop="banlanceMoney" label="用户账号" />
      <el-table-column prop="buyPrice" label="用户类型" />
      <el-table-column prop="buyNumbers" label="金额" />
      <el-table-column prop="buyNumbers" label="状态" />
      <el-table-column prop="buyNumbers" label="类型" />
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="success"
                     @click="handleEdit(scope.$index, scope.row,'修改字典项')">
            审核
          </el-button>
          <el-button size="mini" type="success"
                     @click="handleDelete(scope.$index, scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getAllUserType} from "../../api/b2cbusiness/b2c_admin";
export default {
  name: "AccountTasklist",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      allUserType:[],
      statusOptions: [
        {
          flag:"202111300003" ,
          value:"审核通过",
        },
        {
          flag: "202111300002" ,
          value:"审核未通过",
        },
        {
          flag: "202111300001" ,
          value:"未审核",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    getAllUserType().then(res=>{
      if (res.success){
        console.log(res.data)
        this.allUserType = res.data;
      }
    });
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
